export const version = {
  timeStamp: '2026-07-12 04:55:06 PM ',
  version: '0.0.5',
};
